import { Box, TableCell, Typography } from "@material-ui/core";
import { FC } from "react";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { SchedulePlan, ScheduleReport } from "types/Schedule";
import { getScheduleDateHeadCounts } from "utils/scheduleHelpers";
import { EnchancedSortLabel } from "components/tables/tableSortLabel";
import { ScheduleTableColumn } from "./scheduleTable";
import { useStyles } from "./styles";

interface ScheduleHeadCellStatsProps {
  date?: string;
  station: number;
  dataList: ScheduleReport[];
  planList: SchedulePlan[];
  classes: any;
}

export const ScheduleHeadCellStats: FC<ScheduleHeadCellStatsProps> = ({
  date,
  station,
  dataList,
  planList,
  classes,
}) => {
  const counts = getScheduleDateHeadCounts(date, station, dataList, planList);

  return (
    <Box className={classes.dateHeadStats}>
      <Box className={classes.dateHeadStat}>
        <PersonOutlinedIcon className={`${classes.dateHeadStatIcon} ${counts.drivers !== counts.driverPlan ? classes.errorColor : ""}`} />
        <Typography
          className={`${classes.dateHeadStatText} ${counts.drivers !== counts.driverPlan ? classes.errorColor : ""}`}
        >
          {counts.drivers - counts.helpers}/{counts.driverPlan || 0}
        </Typography>
      </Box>
      <Box className={classes.dateHeadStat}>
        <PeopleAltOutlinedIcon className={`${classes.dateHeadStatIcon} ${counts.helpers !== counts.helperPlan ? classes.errorColor : ""}`} />
        <Typography
          className={`${classes.dateHeadStatText} ${counts.helpers !== counts.helperPlan ? classes.errorColor : ""}`}
        >
          {counts.helpers}/{counts.helperPlan || 0}
        </Typography>
      </Box>
    </Box>
  );
};

export const ScheduleHeadCell: FC<{
  col: ScheduleTableColumn;
  index: number;
  classes: ReturnType<typeof useStyles>;
  sortId: string;
  station: number;
  dataList: ScheduleReport[];
  planList: SchedulePlan[];
  onSortChange: (sortId: string | undefined, cellId: string) => void;
}> = ({ col, index, classes, sortId, station, dataList, planList, onSortChange }) => (
  <TableCell
    className={`${col.dateCol ? classes.tableHeadDateCell : classes.tableHeadCell} ${classes.fixedHeight} ${index < 1 ? "" : classes.tableBorderLeft}`}
  >
    {col.dateCol ? (
      <Box className={classes.dateHeadContent}>
        <Box className={classes.dateHeadDay}>
          <Typography className={classes.dateHeadDayLabel}>
            {col.label.replace(" 2", "").slice(0, 3)}
            {col.date ? `, ${col.date.slice(8, 10)}-${col.date.slice(5, 7)}` : ""}
          </Typography>
        </Box>
        <Box className={classes.dateHeadFooter}>
          <ScheduleHeadCellStats
            date={col.date}
            station={station}
            dataList={dataList}
            planList={planList}
            classes={classes}
          />
        </Box>
      </Box>
    ) : (
      <Box className={classes.contentBox}>
        <EnchancedSortLabel
          columnId={col.id}
          columnLabel={col.label}
          hasSortLabel={Boolean(col.hasSort)}
          handleChange={onSortChange}
          ordering={sortId}
        />
      </Box>
    )}
  </TableCell>
);
